import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface BoolState {
  page: number;
  pageLimit: number;
  pageTracking: number;
  pageLimitTracking: number;
}

const initialState: BoolState = {
  page: 1,
  pageLimit: 5,
  pageTracking: 1,
  pageLimitTracking: 5,
};

const boolSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPageStore: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPageLimitStore: (state, action: PayloadAction<number>) => {
      state.pageLimit = action.payload;
    },
    setPageTrackingStore: (state, action: PayloadAction<number>) => {
      state.pageTracking = action.payload;
    },
    setPageTrackingLimitStore: (state, action: PayloadAction<number>) => {
      state.pageLimitTracking = action.payload;
    },
  },
});

export const {
  setPageStore,
  setPageLimitStore,
  setPageTrackingStore,
  setPageTrackingLimitStore,
} = boolSlice.actions;
export default boolSlice.reducer;
